const data = {
    "lead": "Hello! My name</br> is Christine Kefalianou",
    "sublead": "and I work as a <h1 class='h2 sublead'>Full-Stack Engineer</h1>"
}

export default data;